import { render, staticRenderFns } from "./FormCreatedModified.vue?vue&type=template&id=565781e0&scoped=true"
import script from "./FormCreatedModified.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCreatedModified.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormCreatedModified.vue?vue&type=style&index=0&id=565781e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565781e0",
  null
  
)

export default component.exports